import './App.scss';
import PrivacyPolicy from './pages/privacy-policy/privacy-policy';
import TermOfUse from './pages/terms-of-use/term-of-use';
import React, { Suspense, useEffect } from 'react';
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom"
import Layout from "./components/Layout"
import Home from './pages/home/Home';
import Intro from './pages/intro/intro';
import Vidoes from './pages/vidoes/vidoes';
import i18n from './i18n';
import CommingSoon from './pages/comming-soon/comming-soon';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import gsap from 'gsap';
import SupportServices from './pages/support-services/support-services';
import DigitalCourses from './pages/digital-courses/digital-courses';
import Coursewares from './pages/coursewares/coursewares';
import ClassicLearning from './pages/classic-learning/classic-learning';
import GefenPrograms from './pages/gefen-programs/gefen-programs';
import GefenProgramsBackdrop from './pages/gefen-programs/programs-types/program-type-backdrop';
import MarathonRain from './pages/gefen-programs/programs-types/marathon-rain/marathon-rain';
import BlendedTools from './pages/gefen-programs/programs-types/blended-tools/blended-tools';
import WhoWeAre from './pages/who-we-are/who-we-are';
import ContactUs from './pages/contact-us/contact-us'
import useLocalizeDocumentAttributes from './hooks/use-localize-document-attributes';
import Personaly from './pages/gefen-programs/programs-types/personaly/persoanly';
import VirtualHighSchool from './pages/gefen-programs/programs-types/virtual-high-school/virtual-high-school';
gsap.registerPlugin(useGSAP, ScrollTrigger)

const router = createBrowserRouter([
  {
    path: "/", element: <Layout />, children: [
      { index: true, element: <Home /> },
      { path: "contact-us", element: <ContactUs /> },
      { path: "about", element: <WhoWeAre /> },
      { path: "coursewares", element: <Coursewares /> },
      { path: "classic-learning", element: <ClassicLearning /> },
      { path: "privacy-policy", element: <PrivacyPolicy /> },
      { path: "term-of-use", element: <TermOfUse /> },
      {
        path: "gefen", element: <GefenPrograms />, children: [
          {
            path: "programs", element: <GefenProgramsBackdrop />, shouldRevalidate: false, children: [
              { path: "marathon-rain", element: <MarathonRain /> },
              { path: "blended-tools", element: <BlendedTools /> },
              { path: "personal-ly", element: <Personaly /> },
              { path: "virtual-high-school", element: <VirtualHighSchool /> },
            ]
          },
        ]
      },
      { path: "digital-courses", element: <DigitalCourses /> },
      { path: "support-services", element: <SupportServices /> },
      { path: "comming-soon", element: <CommingSoon /> },
      { path: "vidoes", element: <Vidoes /> },
      { path: "*", element: <Navigate to="/" /> }
    ]
  },
])


function App() {

  useLocalizeDocumentAttributes();

  useEffect(() => {
    gsap.registerPlugin(useGSAP, ScrollTrigger);
  }, []);
  return (

    <Suspense fallback={<Intro />}>
      <RouterProvider router={router} />
    </Suspense>
  )
}
export default App;